import React, { lazy, Suspense } from 'react';

import { Loading } from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';

const LoadableComponent = lazy(() => retry(() => import('./SideCartWidget')));

const SideCartWidgetLoader = () => (
  <Suspense fallback={<Loading />}>
    <LoadableComponent />
  </Suspense>
);

export default SideCartWidgetLoader;
